<template>
  <section>
    <travel-info-list :query="query" />
  </section>
</template>

<script>
import TravelInfoList from '@/components/catalogs/TravelInfoList'

export default {
  name: 'CatalogTravelInfos',
  components: {
    TravelInfoList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
